import axios from "axios";
import { saveManualAuthContext } from "./authContext";
import { encryptPayload, getServerPublicKey, normalizeEncryptedResponseData } from "./encryption";

interface LoginApiResponse {
  data?: {
    token?: string;
    accessToken?: string;
    refreshToken?: string;
    user?: {
      id?: string;
      email?: string;
      tenantId?: string;
    };
  };
  message?: string;
}

export const loginAuthService = {
  async loginWithPassword(baseUrl: string, email: string, password: string) {
    const normalizedBaseUrl = baseUrl.replace(/\/$/, "");
    const loginUrl = `${normalizedBaseUrl}/api/v1/auth/login`;
    // eslint-disable-next-line no-console
    const absoluteLoginUrl = new URL(loginUrl, (globalThis as any).location?.href).href;
    // eslint-disable-next-line no-console
    console.log("[loginAuthService] absolute login URL:", absoluteLoginUrl);
    // eslint-disable-next-line no-console
    console.log("[loginAuthService] fetching server public key from:", `${normalizedBaseUrl}/api/v1/app/encryption/public-key`);
    let serverPublicKey: string;
    try {
      serverPublicKey = await getServerPublicKey(normalizedBaseUrl);
      // eslint-disable-next-line no-console
      console.log("[loginAuthService] got server public key, length:", serverPublicKey.length);
    } catch (e: any) {
      // eslint-disable-next-line no-console
      console.error("[loginAuthService] FAILED to fetch server public key:", e?.message || e);
      throw e;
    }
    const encrypted = await encryptPayload({ email, password }, serverPublicKey);

    let response;
    try {
      // eslint-disable-next-line no-console
      console.log("[loginAuthService] POST", absoluteLoginUrl);
      response = await axios.post<LoginApiResponse>(loginUrl, encrypted.envelope, {
        headers: {
          "Content-Type": "application/json",
          "JC-Client-PKey": encrypted.clientPublicKey,
        },
      });
    } catch (error: any) {
      // eslint-disable-next-line no-console
      console.error("[loginAuthService] POST failed:", {
        status: error?.response?.status,
        data: error?.response?.data,
        message: error?.message,
      });
      const serverMessage = error?.response?.data?.message;
      if (serverMessage) {
        throw new Error(serverMessage);
      }
      if (error?.message === "Network Error") {
        throw new Error("Network error while logging in. Check your connection and try again.");
      }
      throw new Error(error?.message || "Login failed.");
    }

    const normalizedResponse = await normalizeEncryptedResponseData(response.data);
    const payload = normalizedResponse?.data;
    const token = payload?.token || payload?.accessToken;
    const tenantId = payload?.user?.tenantId;
    if (!token || !tenantId) {
      throw new Error(normalizedResponse?.message || "Login response is missing tenant or token.");
    }

    saveManualAuthContext({
      baseUrl: normalizedBaseUrl,
      tenantId,
      userId: payload?.user?.id,
      accessToken: token,
      refreshToken: payload?.refreshToken,
    });

    return {
      email: payload?.user?.email || email,
      tenantId,
    };
  },
};
